import React from "react";
import { Star } from "lucide-react";

export const StarRating = ({ value, count, size = "w-4 h-4", showCount = true, testId }) => {
  if (!value) {
    return <span className="text-xs text-[#A89896]" data-testid={testId}>No reviews yet</span>;
  }
  return (
    <span className="inline-flex items-center gap-1" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} className={`${size} ${n <= Math.round(value) ? "fill-[#E58B5E] text-[#E58B5E]" : "text-[#382A2A]"}`} />
      ))}
      <span className="text-sm text-[#F7ECEB] ml-1">{value.toFixed(1)}</span>
      {showCount && <span className="text-xs text-[#A89896]">({count})</span>}
    </span>
  );
};
